import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Modal,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  SafeAreaView,
  SectionList,
  Pressable,
} from "react-native";
import { createChat } from "../Contact/CreateChat";
import * as ImSdk from "../../../imsdk/api";
import { TopicWithSummary } from "../../../imsdk/api/topic";
import { User } from "../../../imsdk/db/t_user";
import {
  Str_AddMembers,
  Str_Search,
  Str_Confirm,
} from "../../language/string_res";
import {
  white,
  color_EEF3FA,
  color_333333,
  color_666666,
  color_main,
  color_E9E9E9,
  color_BBBBBB,
  color_EDEEF1,
  color_BEBEBE,
  ColorF6F6F6,
  ColorF4F4F4,
} from "../../assets/style/colors";
import { CSearchInput } from "../../components/CSearchInput";
import { LeftView, isSystemAcc } from "./CListItem";
import {
  getAvatarByUser,
  getDisplayName,
  userListByLetter,
} from "../../utils/utils";
import { CheckBoxView } from "../../components/CheckBoxView";
import { Letter } from "../../components/Letter";
import getItemLayout from "../GetItemLayout";
import { ButtonView } from "../../components/ButtonView";

// 就是单聊创建的时候用的
export const CreateGroupModal = (props: {
  users: number[];
  visible: boolean;
  updateVisible: (vis: boolean) => void;
  onClose?: () => void;
  onSubmit?: (topic: TopicWithSummary) => void;
}) => {
  const [selectUsers, setSelectUsers] = useState<User[]>([]);
  const [searchVal, setSearchVal] = useState("");
  const [selecteds, updateSelecteds] = useState<number[]>([]);
  const [section, setSection] = useState<{ title: string; data: User[] }[]>([]);
  const sectionRef =
    useRef<SectionList<any, { title: string; data: User[] }>>(null);
  const isBusy = useRef(false)

  async function initUserList() {
    const im = ImSdk.getInstance();
    // 如果我是P，那么我可以拉取所有人
    const r = await im.GetContact({ isfriend: 1 });
    const contacts = r.users || [];
    // 如果我是F和B，那么我只能拉取同事和P
    // 查本地的数据库
    // 好友、同事、供应链关系 并且不能在当前的群里面
    const newusers = contacts.filter(
      (v) =>
        v.status !== "deleted" &&
        !props.users.includes(v.uid) &&
        !isSystemAcc(v.uid)
    );
    setSelectUsers(newusers);
  }

  useEffect(() => {
    if (props.visible) {
      initUserList().then(() => {});
    }
  }, [props.visible]);

  useEffect(() => {
    if (searchVal === "") {
      const ss = userListByLetter(selectUsers);
      setSection(ss);
    } else {
      const filterUsers = selectUsers.filter((v) => {
        if (!v) return false;
        if (v.email && v.email.includes(searchVal)) return true;
        if (v.remark && v.remark.includes(searchVal)) return true;
        if (v.nick && v.nick.includes(searchVal)) return true;
        if (
          v.nickPY &&
          v.nickPY.toLowerCase().includes(searchVal.toLowerCase())
        )
          return true;
        return !!(v.telno && v.telno.includes(searchVal));
      });
      setSection(userListByLetter(filterUsers));
    }
  }, [selectUsers, searchVal]);

  async function handleSubmit(members: number[]) {
    if (isBusy.current) return;
    isBusy.current = true

    createChat(members.concat(props.users), (topic) => {
      props.onSubmit?.(topic);
      props.updateVisible(false);
      isBusy.current = false;
    })?.catch(() => {
      isBusy.current = false;
    })
  }

  function handleOnclick(item: User) {
    const index = selecteds.indexOf(item.uid);
    if (index > -1) {
      selecteds.splice(index, 1);
    } else {
      selecteds.push(item.uid);
    }
    updateSelecteds([...selecteds]);
  }

  const handleTextChange = useCallback((text: string) => {
    setSearchVal(text);
  }, []);

  if (!props.visible) {
    return null;
  }

  const RenderItem = ({ item }: { item: User }) => {
    const name = getDisplayName(item);
    const left = getAvatarByUser(item);
    const isChecked = selecteds.includes(item.uid);
    return (
      <TouchableOpacity
        activeOpacity={0.6}
        onPress={() => handleOnclick(item)}
        style={styles.itemContainer}
      >
        <View style={styles.itemContent}>
          <CheckBoxView
            disabled={false}
            value={isChecked}
            style={styles.radioBox}
            onValueChange={() => handleOnclick(item)}
          />
          <LeftView left={left} size={48} isRounded={true} isGroup={false} radius={0} />
          <View style={styles.itemTextContainer}>
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              style={styles.itemTitle}
            >
              {name}
            </Text>
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <Modal
      visible={props.visible}
      animationType="fade"
      transparent={true}
      statusBarTranslucent={true}
      onRequestClose={() => props.updateVisible(false)}
    >
      {/* 遮罩层 */}
      <Pressable
        style={styles.overlay}
        onPress={() => props.updateVisible(false)}
      >
        {/* 弹窗内容 */}
        <Pressable
          style={styles.modalContainer}
          onPress={(e) => e.stopPropagation()}
        >
          <Pressable style={{ flex: 1 }}>
            {/* 弹窗头部 */}
            <View style={styles.header}>
              <TouchableOpacity
                style={styles.cancelButton}
                onPress={() => props.updateVisible(false)}
              >
                <Text style={styles.cancelButtonText}>取消</Text>
              </TouchableOpacity>
              <Text style={styles.headerTitle}>{Str_AddMembers}</Text>
              <TouchableOpacity
                style={styles.closeButton}
                onPress={() => props.updateVisible(false)}
              >
                <Text style={styles.closeButtonText}>✕</Text>
              </TouchableOpacity>
            </View>

            {/* 搜索框 */}
            <View style={styles.searchContainer}>
              <CSearchInput
                searchVal={searchVal}
                onChange={handleTextChange}
                placeholder={Str_Search}
                style={styles.searchInput}
              />
            </View>

            {/* 联系人列表 */}
            <View style={{ flex: 1, flexDirection: "row" }}>
              <SectionList
                ref={sectionRef}
                showsHorizontalScrollIndicator={false}
                showsVerticalScrollIndicator={true}
                sections={section}
                keyboardDismissMode="on-drag"
                keyExtractor={(item, index) => item.uid.toString()}
                renderItem={({ item }: { item: User }) => (
                  <RenderItem item={item} />
                )}
                renderSectionHeader={({ section: { title } }) => (
                  <View style={styles.sectionHeader}>
                    <Text style={styles.sectionTitle}>{title}</Text>
                  </View>
                )}
                contentContainerStyle={styles.listContent}
                getItemLayout={getItemLayout({
                  getItemHeight: 64,
                  getSectionHeaderHeight: 40,
                })}
                style={styles.sectionList}
              />
              <Letter
                section={section}
                scrollToLocation={(index) => {
                  sectionRef.current?.scrollToLocation({
                    animated: true,
                    itemIndex: 0,
                    sectionIndex: index,
                  });
                }}
              />
            </View>

            {/* 底部按钮 */}
            <View style={styles.bottomButtonContainer}>
              <ButtonView
                style={[
                  styles.submitButton,
                  {
                    backgroundColor: selecteds.length
                      ? color_main
                      : color_E9E9E9,
                  },
                ]}
                textStyle={{
                  color: selecteds.length ? white : color_BBBBBB,
                  fontSize: 16,
                  fontWeight: "500",
                }}
                onPress={() => {
                  if (selecteds.length) {
                    handleSubmit(selecteds);
                  }
                }}
                text={
                  selecteds.length
                    ? `${Str_Confirm}(${selecteds.length})`
                    : Str_Confirm
                }
              />
            </View>
          </Pressable>
        </Pressable>
      </Pressable>
    </Modal>
  );
};

const styles = StyleSheet.create({
  // 遮罩层样式
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  // 弹窗容器样式
  modalContainer: {
    backgroundColor: white,
    borderRadius: 12,
    width: "100%",
    maxWidth: 600,
    maxHeight: "80%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  // 弹窗头部样式
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: ColorF6F6F6,
    backgroundColor: "#FAFAFA",
  },
  // 头部标题样式
  headerTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: color_333333,
  },
  // 取消按钮样式
  cancelButton: {
    minWidth: 60,
    alignItems: "flex-start",
    padding: 8,
  },
  cancelButtonText: {
    fontSize: 16,
    color: color_333333,
    fontWeight: "400",
  },
  // 关闭按钮样式
  closeButton: {
    padding: 8,
    borderRadius: 4,
    backgroundColor: "transparent",
  },
  closeButtonText: {
    fontSize: 20,
    color: color_333333,
    lineHeight: 20,
  },
  // 搜索容器样式
  searchContainer: {
    padding: 16,
    backgroundColor: white,
    borderBottomWidth: 1,
    borderBottomColor: "#F0F0F0",
  },
  // 搜索输入框样式
  searchInput: {
    backgroundColor: "#F8F9FA",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ColorF6F6F6,
  },
  // 联系人列表样式
  sectionList: {
    flex: 1,
    backgroundColor: white,
  },
  // 列表内容样式
  listContent: {
    paddingBottom: 8,
  },
  // 分组头部样式
  sectionHeader: {
    height: 40,
    justifyContent: "center",
    backgroundColor: color_EEF3FA,
    paddingLeft: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#F0F0F0",
  },
  // 分组标题样式
  sectionTitle: {
    color: color_666666,
    fontSize: 14,
    fontWeight: "600",
  },
  // 联系人项容器样式
  itemContainer: {
    width: "100%",
    backgroundColor: white,
    paddingHorizontal: 16,
    paddingVertical: 12,
    minHeight: 64,
    justifyContent: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#F8F9FA",
  },
  // 联系人项内容样式
  itemContent: {
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  // 复选框样式
  radioBox: {
    width: 24,
    height: 24,
    marginRight: 12,
    borderWidth: 2,
    borderColor: color_BEBEBE,
    borderRadius: 12,
  },
  // 联系人信息容器样式
  itemTextContainer: {
    flex: 1,
    marginLeft: 4,
  },
  // 联系人姓名样式
  itemTitle: {
    fontSize: 16,
    color: color_333333,
    fontWeight: "500",
  },
  // 底部按钮容器样式
  bottomButtonContainer: {
    backgroundColor: white,
    width: "100%",
    padding: 16,
    flexDirection: "row-reverse",
    borderTopWidth: 1,
    borderTopColor: ColorF6F6F6,
  },
  // 提交按钮样式
  submitButton: {
    fontSize: 16,
    paddingVertical: 12,
    paddingHorizontal: 32,
    margin: 0,
    borderRadius: 8,
    minWidth: 120,
    alignItems: "center",
    justifyContent: "center",
  },
});
